module.exports = __webpack_public_path__ + "img/06.ac62a81d.png";